export const publicRoutes: Record<string, string> = {
  users: "/users",
  devices: "/devices",
  orgs: "/orgs",
};
